import { render, staticRenderFns } from "./RankingFilter.vue?vue&type=template&id=1b560340&"
import script from "./RankingFilter.vue?vue&type=script&lang=js&"
export * from "./RankingFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports